/* tslint:disable */

import VueRouter, { Route } from 'vue-router';
import { TemporaryCacheKeys } from 'msal/lib-commonjs/utils/Constants';

import { AuthenticationContext } from './authentication-context';
import { AuthenticationResult } from './authentication-result';
import { MsalConfig } from './msal-config';
import { MSALError } from './msal-error';

export class MsalGuard {
    private loginScopes: string[];
    constructor(private config: MsalConfig, private authContext: AuthenticationContext) 
    { 
        this.loginScopes = config.consentScopes || [];
    }

    public initRouter(router: VueRouter) {
        router.beforeEach(this.beforeEach.bind(this));
    }

    private beforeEach(to: Route, from: Route, next: any) {
        if (!to.matched.some(record => record.meta.requireAuth)) {
        return next();
        }

        this.authContext.getLogger().verbose("location change event from old url to new url");

        this.authContext.updateDataFromCache(this.loginScopes);

        if (!this.authContext._oauthData.isAuthenticated && !this.authContext._oauthData.userName) {
            if (to.fullPath) {

                if (!this.authContext._renewActive && !this.authContext.loginInProgress()) {

                    const loginStartPage = this.getBaseUrl(to) + to.fullPath;
                    if (loginStartPage !== null) {
                        this.authContext.getCacheStorage().setItem(TemporaryCacheKeys.LOGIN_REQUEST, loginStartPage);
                    }
                    if (this.config.popUp) {
                        return new Promise((resolve, reject) => {
                            this.authContext.loginPopup({scopes: this.loginScopes}).then(function (token) {
                                resolve(next());
                            }, function (error) {
                                reject(next(from.fullPath));
                            })
                        });
                    }
                    else {
                        this.authContext.loginRedirect({scopes: this.loginScopes});
                    }
                }
            }
        }
        //token is expired/deleted but userdata still exists in _oauthData object
        else if (!this.authContext._oauthData.isAuthenticated && this.authContext._oauthData.userName) {
            return new Promise((resolve, reject) => {
                this.authContext.acquireTokenSilent({scopes: this.loginScopes}).then((token: any) => {
                    if (token) {
                        this.authContext._oauthData.isAuthenticated = true;
                        const authenticationResult = new AuthenticationResult(token);
                        this.authContext.broadcastService.broadcast("msal:loginSuccess",  authenticationResult);
                        resolve(next());
                    }
                }, (error: any) => {
                    const errorParts = error.errorMessage;
                    const msalError = new MSALError(error.errorCode, errorParts, "");
                    this.authContext.broadcastService.broadcast("msal:loginFailure", msalError);
                    this.authContext.loginRedirect({scopes: this.loginScopes});
                    resolve(false);
                });
            });
        }
        else {
        next();
        }
    }

    isEmpty = function (str: any) {
        return (typeof str === "undefined" || !str || 0 === str.length);
    };

    private getBaseUrl(route: Route): string {
        let currentAbsoluteUrl = window.location.href;
        const currentRelativeUrl = route.path;
        if (this.isEmpty(currentRelativeUrl)) {
            if (currentAbsoluteUrl.endsWith("/")) {
                currentAbsoluteUrl = currentAbsoluteUrl.replace(/\/$/, '');
            }
            return currentAbsoluteUrl;
        }
        else {
            const index = currentAbsoluteUrl.indexOf(currentRelativeUrl);
            return currentAbsoluteUrl.substring(0, index);
        }
    }
}